exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-paginated-table[data-v-6afdfc90] {\r\n    width: 100%;\r\n    border-collapse: collapse;\n}\n.md-table-head[data-v-6afdfc90],\r\n.md-table-cell[data-v-6afdfc90] {\r\n    width: 50%;\r\n    padding: 10px;\r\n    border-top: 1px solid #ddd;\r\n    border-bottom: 1px solid #ddd;\n}\n.table-gap[data-v-6afdfc90] {\r\n    height: 10px;\n}\ninput[type='checkbox'][data-v-6afdfc90] {\r\n    margin-left: 10px;\n}\r\n", ""]);

// exports
